<template>
  <div class="auth-screen">
    <h2 class="mb-4">
      Change Password
    </h2>
    <b-container class="auth-block has-border">
      <b-row>
        <b-col>
          <b-form-input
            v-model="newPassword"
            type="password"
            title="New Password"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col class="d-flex justify-content-end flex-no-wrap ml-3 mt-3">
          <div
            v-if="!!error"
            class="mr-4 alert alert-danger fade show"
            role="alert"
          >
            {{ error }}
          </div>
          <div class="ml-2 d-flex flex-nowrap align-content-end align-items-end">
            <b-button
              class="ml-2 mr-2"
              title="Cancel"
              :disabled="loading"
              @click="onCancel"
            >
              Cancel
            </b-button>
            <b-button
              variant="primary"
              title="Reset Password"
              @click="onSubmitChangeForm"
              @keyup.13="onSubmitChangeForm"
            >
              Change Password
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <div class="mt-4 d-flex">
      Users are required to change their password from the initial password
      created on account creation.<br>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChangePassword',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      newPassword: ''
    }
  },
  computed: {},
  methods: {
    onCancel() {
      this.$emit('cancel-change')
    },
    onSubmitChangeForm() {
      this.$emit('submit-change', this.newPassword)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/assets/styles/main.scss';
  @import '~@/assets/styles/auth.scss';
</style>
